import './ContactUs.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './AboutUs.lang.json';

const AboutUs = () => {
  const { lang } = useLanguage(translations);

  return (
    <div className="contactUsTextContainer">
      <h2 className="contactUsTitle">{lang('aboutUsTitle')}</h2>
      <div className="contactUsTextContent">
        <p>{lang('aboutUsParagraph1')}</p>

        <p>{lang('aboutUsParagraph2')}</p>
      </div>
    </div>
  );
};

export default AboutUs;
